import { LimitBaseInput, LimitScope, LimitType } from './types';
import { getTransactionConfiguration } from './get-transaction-configuration';
import { getGlobalOrMembershipLimitConfiguration } from './get-global-or-membership-limit-configuration';

export const getLimitConfiguration = (
  limitScope: LimitScope | LimitScope.Membership | LimitScope.Global,
  values: LimitBaseInput,
  limitType: LimitType,
) => {
  return limitScope === LimitScope.Transaction
    ? getTransactionConfiguration(values)
    : getGlobalOrMembershipLimitConfiguration(values, limitType, limitScope);
};
